/**
 * 下单幂等键(clientUuid)生成。进 W-9 下单页 mount 时生成一次、跨重试稳定,
 * 命中后端 `uk_order_client_uuid` → 同 buyer+product 返同一订单,防重复下单(FR-C2)。
 * 语义对齐 rn-app `pages/order-preview/clientUuid.ts`(纯幂等键,非加密用途)。
 */

/** 生成 32 位 hex 幂等键(满足后端 8–64 字符约束)。 */
export function generateClientUuid(): string {
  // 优先 crypto.randomUUID(去连字符 → 32 hex);老浏览器回退到 getRandomValues。
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID().replace(/-/g, '');
  }
  if (c && typeof c.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    c.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  }
  // 极端回退(测试/无 crypto 环境):时间戳 + 计数,仅作幂等键,不要求加密强度。
  let s = Date.now().toString(16);
  while (s.length < 32) s += Math.floor((s.length * 2654435761) % 0xffffffff).toString(16);
  return s.slice(0, 32);
}
